module.exports = __webpack_public_path__ + "img/csgo.cc964412.jpg";